import { render, staticRenderFns } from "./PropertyAncientHistory.vue?vue&type=template&id=04020250"
import script from "./PropertyAncientHistory.vue?vue&type=script&lang=ts"
export * from "./PropertyAncientHistory.vue?vue&type=script&lang=ts"
import style0 from "./PropertyAncientHistory.vue?vue&type=style&index=0&id=04020250&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports